import TopNLineMerger from "@/classes/lineMetricMerge/TopNLineMerger";

export default class TopNDecompositionLineMerger extends TopNLineMerger {
  protected get mergeKey(): string {
    return this.settings?.decompositionMetric ?? "";
  }
}
